import { JobOptionSvcOptions } from 'domains/jobconfigDomain';
import { UOMCoefficientEnum } from 'domains/svcDomain';
import { useMemo } from 'react';
import { ConfigSvcProps } from '..';

interface IProps extends ConfigSvcProps {
  customerParameterLabels?: string[];
  customerOptions?: JobOptionSvcOptions[];
}

export const useHideSvcContainer = (props: IProps) => {
  const {
    jobOptionSvc,
    formCache,
    customerParameterLabels,
    customerOptions,
    id,
    disabled,
  } = props;

  const hideSvc = useMemo(() => {
    return !jobOptionSvc?.isRequired && !formCache?.[id]?.name;
  }, [jobOptionSvc?.isRequired, id, formCache]);

  const hideJobSvcSpec = useMemo(() => {
    return (
      Boolean(!jobOptionSvc?.specs?.length) ||
      (Boolean(!customerParameterLabels?.length) &&
        Boolean(!jobOptionSvc?.parameterLabels?.length))
    );
  }, [jobOptionSvc, customerParameterLabels]);

  const hideJobSvcOption = useMemo(() => {
    return (
      Boolean(!customerOptions?.length) &&
      Boolean(!jobOptionSvc?.options?.length)
    );
  }, [customerOptions, jobOptionSvc]);

  const hideJobSvcQuantityPerBundle = useMemo(() => {
    return jobOptionSvc?.uomCoefficient !== UOMCoefficientEnum.BUNDLE_COUNT;
  }, [jobOptionSvc]);

  const hideJobSvcInstructions = useMemo(() => {
    return Boolean(!jobOptionSvc?.showInstructions);
  }, [jobOptionSvc]);

  const hideJobSvcMessage = useMemo(() => {
    return Boolean(!jobOptionSvc?.message);
  }, [jobOptionSvc]);

  return Boolean(
    hideSvc ||
      disabled ||
      (hideJobSvcSpec &&
        hideJobSvcOption &&
        hideJobSvcQuantityPerBundle &&
        hideJobSvcInstructions &&
        hideJobSvcMessage)
  );
};
